import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Link from "react-scroll/modules/components/Link";
import Logo from "../headerDeskComponents/logo";
import Support from "../headerDeskComponents/support";
import SignUp from "../headerDeskComponents/signUp";
import Search from "../headerDeskComponents/search";
import NavMenu from "./NavMenu";
import EdModal from "@frameworks/web/components/generic/edModal";
import ReportContent from "./ReportContent";
import EssentialReportData from "./EssentialReportData";
import { MarketSlidingPane } from "@frameworks/web/components/generic/MarketSlider/MarketSlidingPane";
import ChartiqBtmDrawer from "@frameworks/web/components/generic/ChartiqBtmDrawer";
import { MarketIconBlock } from "@frameworks/web/components/generic/SlidingPaneIconBlock/MarketIconBodyBlock";
import ShowLoginPopup from "@frameworks/web/components/features/LoginFlow/ShowLoginPopup";
import TocHoc from "@frameworks/web/components/features/TOC/TocHoc";
import MutualFund from "@frameworks/web/components/features/TOC/MutualFund/MutualFund";
const NavHeader = (props) => {
    const [moreReport, setMoreReport] = useState(false);
    const [searchPop, setSearchPop] = useState(false);
    const onCloseGoBackFunction = () => {
        setMoreReport(false);
    };
    const [showToc, setShowToc] = React.useState(false);
    const [showMFToc, setShowMFToc] = React.useState(false);
    const [symbol, setSymbol] = React.useState("");
    return (React.createElement("div", null,
        React.createElement(Row, { className: "refactor-header-section mx-0" },
            React.createElement(Col, { lg: 12, className: "px-0" },
                React.createElement("header", { className: "header-info" },
                    React.createElement("div", { className: "navbar" },
                        React.createElement("div", { className: "displayFlex gap-50" },
                            React.createElement(Link, { to: "/" },
                                React.createElement(Logo, null)),
                            React.createElement("header", { className: "header-menu navigation-menu" },
                                React.createElement("div", { className: "navbar pt-0 pb-0" },
                                    React.createElement(NavMenu, { setMoreReport: setMoreReport })))),
                        React.createElement("div", { className: "displayFlex supportNotify" },
                            React.createElement("div", { className: "search icon-serachbar aligncenteritem", onClick: () => {
                                    setSearchPop(true);
                                } },
                                React.createElement("span", { className: "edel-icon-search" })),
                            searchPop && (React.createElement(Search, { searchPopup: searchPop, setSearchPopup: setSearchPop, setShowToc: setShowToc, setSymbol: setSymbol, setShowMfToc: setShowMFToc })),
                            React.createElement(Support, null),
                            React.createElement(SignUp, null)))))),
        moreReport && (React.createElement(React.Fragment, null,
            React.createElement(EdModal, { show: moreReport, setShow: setMoreReport, modalTitle: "commonmodal gray-modal ", title: "All Reports", size: "modal-lg modal-dialog-centered", showFooter: false, DisableOutsideClickClose: true, onCloseGoBack: true, onCloseGoBackFunction: onCloseGoBackFunction },
                React.createElement("div", { className: "px-3" },
                    React.createElement("div", { className: "leftsection-grid grid-4 gap-20 mgt-20 mb-40" },
                        React.createElement(EssentialReportData, null)),
                    React.createElement("div", null,
                        React.createElement(ReportContent, null)))))),
        showToc && (React.createElement(MarketSlidingPane, { setSwitchKey: () => {
                setShowToc(false);
                setSymbol("");
            }, children: React.createElement(React.Fragment, null,
                React.createElement("div", { className: "common-drawer-scroll" },
                    React.createElement(MarketIconBlock, { isAddToWatchlist: true, isViewQuote: true }),
                    React.createElement(ChartiqBtmDrawer, { symbol: symbol, instru: "" }))), symbol: symbol })),
        showMFToc && (React.createElement(ShowLoginPopup, { children: React.createElement(TocHoc, { component: () => React.createElement(MutualFund, { isin: symbol }), setShowTOC: () => {
                    setShowMFToc(false);
                    setSymbol("");
                } }), popupCloseFunction: () => {
                setShowMFToc(false);
                setSymbol("");
            } }))));
};
export default NavHeader;
